module.exports = __webpack_public_path__ + "img/idea3.4e3e99af.png";